import { render, staticRenderFns } from "./About1920.vue?vue&type=template&id=3c797381&scoped=true"
import script from "./About1920.vue?vue&type=script&lang=js"
export * from "./About1920.vue?vue&type=script&lang=js"
import style0 from "./About1920.vue?vue&type=style&index=0&id=3c797381&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c797381",
  null
  
)

export default component.exports